import { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";

function EditIPGroup({ ipGroup, setEditIP }) {
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    if (edit) {
      setEditIP({ ...ipGroup, uid: ipGroup.id });
    }
  }, [edit]);

  return (
    <IconButton onClick={() => setEdit(true)}>
      <EditIcon />
    </IconButton>
  );
}

export default EditIPGroup;
